import styled from "styled-components";
import { media, theme } from "../../../../../helpers/theme";

export type SummaryPropertyItem = {
  propertyKey: string | undefined;
  propertyName: string | undefined;
  propertyValue: string | string[] | undefined;
};

interface SummaryProps {
  data: SummaryPropertyItem[];
}

export const Summary = (props: SummaryProps) => {
  return (
    <Container>
      {props.data.map((property, index) => (
        <Item>
          {property.propertyValue ? (
            <SumamryWraper key={property.propertyKey}>
              <SummaryItemName>{property.propertyName}:</SummaryItemName>
              <SummaryItemValue>{property.propertyValue}</SummaryItemValue>
            </SumamryWraper>
          ) : (
            <></>
          )}
        </Item>
      ))}
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 950px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
const Item = styled.div`
@media (min-width: 950px) {
 width:48%;
}
}
`;
const SumamryWraper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  width: max-content;
  margin-bottom: 1px;
  white-space: break-spaces;
  align-items: flex-start;
  width: 100%;
  padding-bottom: 10px;
  @media (min-width: 950px) {
    //width: 48%;
    padding-bottom: 16px;
  }
  @media (max-width: 299px) {
    justify-content: space-between !important;
  }
`;
const SummaryItemName = styled.div`
  padding: 0px 0px;
  color: ${theme.colors.gray01_secondaryText};
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  @media (max-width: 950px) and (min-width: 300px) {
    min-width: 143px;
  }
  @media (min-width: 951px) {
    min-width: 170px;
  }
`;

const SummaryItemValue = styled.div`
  padding: 0px 0px 0px 10px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
  overflow-wrap: break-word;
  align-content: center;
  white-space: break-spaces;
  @media (max-width: 299px) {
    text-align: right;
  }
`;
